export const skillDetails = [
    {
      title: "React",
      level: "Advanced",
      details: [
        {
          title: "UI/UX Development",
          description: "Build responsive interfaces with React Router, Formik, and UI frameworks."
        },
        {
          title: "API Integration",
          description: "Integrate APIs with Axios/Fetch, manage data with async/await."
        },
        {
          title: "Advanced Patterns",
          description: "Master render props, HOCs, compound components, and custom hooks."
        },
        {
          title: "Deployment & CI/CD",
          description: "Understand deployment on Netlify/Vercel and automated CI/CD pipelines."
        },
        {
          title: "Progressive Web Apps (PWA)",
          description: "Understand PWAs for better user experience, especially on mobile."
        },
        {
          title: "WebSockets & Real-Time Data",
          description: "Use WebSockets/Socket.io for real-time communication applications."
        }
      ]
    },
    {
      title: "Tailwind CSS",
      level: "Advanced",
      details: [
        {
          title: "UI/UX Styling",
          description: "Create responsive, customizable designs using utility-first Tailwind classes."
        },
        {
          title: "Responsive Design",
          description: "Leverage Tailwind's responsive modifiers for adaptive layouts across devices."
        },
        {
          title: "Customization & Theming",
          description: "Extend Tailwind with custom themes, colors, and configuration files."
        },
        {
          title: "Component Design",
          description: "Design reusable components with Tailwind's utility-first approach."
        },
        {
          title: "Advanced CSS Features",
          description: "Utilize advanced utilities like grid, flex, animations, and transitions."
        },
        {
          title: "RTL Support",
          description: "Implement RTL support in Tailwind for languages like Arabic or Hebrew."
        },
        {
          title: "JIT Mode",
          description: "Enable JIT mode for faster builds and dynamic class generation."
        },
        {
          title: "Build Tools & Automation",
          description: "Integrate Tailwind with build tools like Webpack, PostCSS, or Vite."
        }
      ]
    },
    {
      title: "PHP",
      level: "Intermediate",
      details: [
        {
          title: "OOP",
          description: "Use classes, objects, inheritance, and polymorphism to structure code."
        },
        {
          title: "Database Integration",
          description: "Interact with databases using PDO or MySQLi for secure queries."
        },
        {
          title: "PHP Frameworks",
          description: "Work with PHP frameworks like Laravel or Symfony for rapid development."
        },
        {
          title: "Security Best Practices",
          description: "Implement security measures like input validation, prepared statements, and hashing."
        },
        {
          title: "Unit Testing",
          description: "Write unit tests for PHP code using PHPUnit or similar tools."
        },
        {
          title: "Error Handling",
          description: "Implement try-catch blocks for exceptions and manage errors gracefully."
        },
        {
          title: "Session Management",
          description: "Manage user sessions and cookies for authentication and persistence."
        }
      ]
    },
    {
      title: "JavaScript",
      level: "Advanced",
      details: [
        {
          title: "Asynchronous Programming",
          description: "Master async/await, Promises, and callback functions for handling asynchronous code."
        },
        {
          title: "Closures & Scopes",
          description: "Understand closures, lexical scoping, and their applications in real-world scenarios."
        },
        {
          title: "ES6+ Features",
          description: "Use modern JavaScript features like destructuring, spread/rest operators, and template literals."
        },
        {
          title: "Event Loop & Concurrency",
          description: "Understand the event loop, microtasks, and macrotasks for concurrency management."
        },
        {
          title: "Functional Programming",
          description: "Implement higher-order functions, map/filter/reduce, currying, and immutability."
        },
        {
          title: "Optimizing Performance",
          description: "Apply best practices for optimizing performance, like lazy loading, throttling, and debouncing."
        },
        {
          title: "Testing & Debugging",
          description: "Write unit and integration tests using tools like Jest, Mocha, or Jasmine; use debugging tools in browser dev tools."
        },
        {
          title: "Module System",
          description: "Use ES6 modules, CommonJS, and module bundlers (Webpack, Rollup) for code organization."
        },
        {
          title: "Error Handling",
          description: "Handle errors effectively using try/catch, custom error types, and error boundaries."
        },
        {
          title: "JavaScript Engines",
          description: "Understand the inner workings of JavaScript engines like V8 and JIT compilation."
        }
      ]
    },
    {
      title: "React Native",
      level: "Intermediate",
      details: [
        {
          title: "Component Development",
          description: "Build reusable and maintainable UI components using React Native's core components."
        },
        {
          title: "Navigation",
          description: "Implement navigation with React Navigation (Stack, Tab, Drawer) and deep linking."
        },
        {
          title: "State Management",
          description: "Use state management libraries like Redux, Context API, or Zustand for global state."
        },
        {
          title: "Styling",
          description: "Style components using StyleSheet, Flexbox, and integrate with libraries like Styled Components."
        },
        {
          title: "API Integration",
          description: "Integrate with REST APIs or GraphQL for data fetching and handling asynchronous operations."
        },
        {
          title: "Native Modules",
          description: "Link and use native modules (Java, Objective-C, Swift) for custom functionality."
        },
        {
          title: "Performance Optimization",
          description: "Optimize performance using techniques like FlatList, memoization, and lazy loading."
        },
        {
          title: "Debugging",
          description: "Debug React Native apps using tools like React Native Debugger, Chrome DevTools, or Flipper."
        },
        {
          title: "Offline Storage",
          description: "Implement offline data storage with libraries like Redux Persist or SQLite."
        },
        {
          title: "Build & Deployment",
          description: "Understand building apps for iOS and Android, including debugging, testing, and deployment to App Store/Google Play."
        }
      ]
    },
    {
      title: "Flutter",
      level: "Advanced",
      details: [
        {
          title: "Custom Widgets",
          description: "Build complex, reusable custom widgets to enhance UI flexibility."
        },
        {
          title: "State Management",
          description: "Master state management solutions like Provider, Riverpod, Bloc, and GetX."
        },
        {
          title: "Animations",
          description: "Implement advanced animations using `AnimationController`, `Tween`, and `Hero` for smooth transitions."
        },
        {
          title: "Navigation",
          description: "Manage complex navigation with `Navigator`, `Navigator 2.0`, and deep linking."
        },
        {
          title: "Performance Optimization",
          description: "Optimize Flutter performance with techniques like widget tree pruning, lazy loading, and reducing rebuilds."
        },
        {
          title: "Async Programming",
          description: "Handle asynchronous operations efficiently using `Future`, `Stream`, and `async/await`."
        },
        {
          title: "Platform-Specific Code",
          description: "Write platform-specific code using platform channels to access native APIs (Android/iOS)."
        },
        {
          title: "Custom Themes & Styles",
          description: "Create dynamic themes and customize Flutter widgets with ThemeData and custom styles."
        },
        {
          title: "Testing",
          description: "Write unit tests, widget tests, and integration tests using Flutter’s testing framework."
        },
        {
          title: "CI/CD & Deployment",
          description: "Implement CI/CD pipelines using tools like Codemagic or GitHub Actions for automated testing and deployment to Google Play and the App Store."
        }
      ]
    },
    {
      title: "Swift",
      level: "Intermediate",
      details: [
        {
          title: "Object-Oriented Programming",
          description: "Implement classes, structs, inheritance, and protocols for structuring code."
        },
        {
          title: "Optionals & Unwrapping",
          description: "Understand optionals, force unwrapping, optional binding, and nil coalescing."
        },
        {
          title: "Closures & Functions",
          description: "Work with closures, capturing values, and higher-order functions for flexibility."
        },
        {
          title: "Memory Management",
          description: "Use Automatic Reference Counting (ARC) and handle memory leaks with weak/strong references."
        },
        {
          title: "Protocols & Delegates",
          description: "Implement protocols and delegates to establish communication between components."
        },
        {
          title: "UI Development",
          description: "Create UI using UIKit or SwiftUI, and implement Auto Layout for responsive design."
        },
        {
          title: "Networking",
          description: "Make network requests using URLSession, parse JSON with Codable, and handle errors gracefully."
        },
        {
          title: "Core Data",
          description: "Use Core Data for local data storage and manage the object graph."
        },
        {
          title: "Concurrency",
          description: "Work with GCD (Grand Central Dispatch) or Swift Concurrency (async/await) for background tasks."
        },
        {
          title: "Testing",
          description: "Write unit tests and UI tests using XCTest framework to ensure code reliability."
        }
      ]
    },
    {
      title: "Kotlin",
      level: "Basic",
      details: [
        {
          title: "Basic Syntax",
          description: "Understand variables, data types, and control flow (if, when, loops)."
        },
        {
          title: "Functions",
          description: "Create and call functions, including using default and named parameters."
        },
        {
          title: "Null Safety",
          description: "Handle nullable types with safe calls (`?.`), the Elvis operator (`?:`), and `!!`."
        },
        {
          title: "Classes & Objects",
          description: "Define classes, create objects, and understand constructors and initialization."
        },
        {
          title: "Collections",
          description: "Work with lists, sets, and maps, including basic operations like iteration and modification."
        },
        {
          title: "String Manipulation",
          description: "Use string templates, string interpolation, and basic string functions."
        },
        {
          title: "Conditional Expressions",
          description: "Utilize `if` and `when` expressions for conditional logic and returning values."
        },
        {
          title: "Basic Lambdas",
          description: "Implement basic lambda functions and higher-order functions for functional programming."
        },
        {
          title: "Error Handling",
          description: "Use `try-catch` blocks for exception handling and safe error management."
        },
        {
          title: "Basic Input/Output",
          description: "Perform basic input and output operations using `readLine()` and `println()`."
        },
        {
          title: "Gradle Project Setup & Management",
          description: "Set up and manage Kotlin projects, handle dependencies, and automate builds. Run basic tasks like `build`, `clean`, and `test`, and use Kotlin DSL for better type safety and readability in configuration."
        }
      ]
    },
    {
      title: "Git",
      level: "Intermediate",
      details: [
        {
          title: "Version Control Mastery",
          description: "Comprehensively understand the core concepts of Git: commits, branching, merging, rebasing, and conflict resolution."
        },
        {
          title: "Branching & Merging Strategies",
          description: "Master complex branching strategies such as GitFlow, GitHub Flow, and trunk-based development."
        },
        {
          title: "Rebasing & Cherry-Picking",
          description: "Use git rebase for linear history and cleaner commits, understand interactive rebasing for squashing commits."
        },
        {
          title: "Advanced Merging Techniques",
          description: "Manage advanced merges and handle tricky merge conflicts in large, multi-developer environments."
        },
        {
          title: "Commit History & Blame Management",
          description: "Master git log and advanced filtering for visualizing commit history and detailed code inspection."
        },
        {
          title: "Rewriting Commit History",
          description: "Master history manipulation tools for clean, concise commit history in collaborative environments."
        },
        {
          title: "Tagging & Releases",
          description: "Create and manage annotated and lightweight tags for release management and version tracking."
        },
        {
          title: "Submodules & Subtrees",
          description: "Work with Git submodules and subtrees for managing dependencies and large projects."
        },
        {
          title: "Remote Repository Management",
          description: "Manage remotes with advanced workflows and complex pull requests."
        },
        {
          title: "Git Hooks & Automation",
          description: "Automate workflows using Git hooks and integrate with linters and CI/CD pipelines."
        }
      ]
    },
    {
      title: "Docker",
      level: "Basic",
      details: [
        {
          title: "Introduction to Containers",
          description: "Understand containers and how they differ from virtual machines."
        },
        {
          title: "Installing Docker",
          description: "Install Docker and understand Docker Desktop and Engine components."
        },
        {
          title: "Docker Images",
          description: "Work with Docker images, pull from Docker Hub, and create custom images."
        },
        {
          title: "Running Containers",
          description: "Run containers with port mapping and environment variables management."
        },
        {
          title: "Docker Containers Management",
          description: "Manage container lifecycle with basic Docker commands."
        },
        {
          title: "Basic Security Practices",
          description: "Implement basic Docker security best practices and container hardening."
        }
      ]
    },
    {
      title: "Google Cloud",
      level: "Basic",
      details: [
        {
          title: "GCP Overview",
          description: "Understand basic services including Compute Engine, GKE, and Cloud Storage."
        },
        {
          title: "Compute Engine",
          description: "Set up and manage VMs in Google Cloud for infrastructure management."
        },
        {
          title: "Cloud Storage",
          description: "Manage data storage with Google Cloud Storage buckets and operations."
        },
        {
          title: "IAM & Security",
          description: "Set up and manage IAM roles to control access to Cloud resources."
        },
        {
          title: "Cloud Console & CLI",
          description: "Navigate Cloud Console and use CLI for resource management."
        }
      ]
    },
    {
      title: "Digital Product Design",
      level: "Advanced",
      details: [
        {
          title: "UI/UX Design",
          description: "Create intuitive interfaces using Figma, Sketch, or Adobe XD."
        },
        {
          title: "Product Design",
          description: "Define product flow and features from concept to delivery."
        },
        {
          title: "Motion Graphics",
          description: "Design dynamic visuals and animations for enhanced user engagement."
        },
        {
          title: "Visual Design",
          description: "Craft cohesive designs using typography, color theory, and graphic elements."
        },
        {
          title: "Interaction Design",
          description: "Design interactive elements that improve usability and user experience."
        },
        {
          title: "Data-Driven Design",
          description: "Use analytics tools to inform design decisions based on user behavior data."
        }
      ]
    }
  ];
  
  export default skillDetails;
